import type { PropsWithChildren } from 'react';

import { VBaseCheckboxRadioGroup } from '../VBaseCheckboxRadioGroup';
import VRadioGroupItem from './VRadioGroupItem';

const VRadioGroup = ({
  children,
  defaultValue,
  value,
  onValueChange,
}: PropsWithChildren<{
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
}>) => {
  return (
    <VBaseCheckboxRadioGroup
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      {children}
    </VBaseCheckboxRadioGroup>
  );
};

VRadioGroup.Item = VRadioGroupItem;

export default VRadioGroup;
